import React, { useState } from 'react';

interface InvoiceSearchFilterProps {
  onSearch?: (query: string) => void;
}

export default function InvoiceSearchFilter({ onSearch }: InvoiceSearchFilterProps) {
  const [query, setQuery] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch?.(query);
  };

  const handleChipClick = (sampleQuery: string) => {
    setQuery(sampleQuery);
    onSearch?.(sampleQuery);
  };

  return (
    <div className="mb-6">
      <form onSubmit={handleSubmit} className="flex gap-2">
        <div className="relative flex-1">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3.5 pointer-events-none text-brand-soft">
            <svg className="w-4 h-4 fill-current" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
          </span>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search invoices... (type 'amazon', 'electricity', 'over €500'...)"
            className="w-full pl-10 pr-4 py-2.5 rounded-xl text-xs sm:text-sm bg-white dark:bg-boxdark border border-brand-line dark:border-strokedark text-brand-navy dark:text-white placeholder-brand-soft focus:outline-none focus:border-brand-vib shadow-sm"
          />
        </div>

        <button
          type="submit"
          className="px-5 py-2.5 rounded-xl text-xs sm:text-sm font-semibold bg-brand-vib text-white hover:bg-brand-vib-hover transition-colors shadow-sm"
        >
          Search
        </button>
      </form>

      {/* Suggested Query Chips */}
      <div className="flex flex-wrap items-center gap-2 mt-2.5 text-xs text-brand-muted dark:text-bodydark">
        <span className="font-mono text-[11px] text-brand-soft">Try:</span>
        <button
          type="button"
          onClick={() => handleChipClick('amazon')}
          className="px-2.5 py-0.5 rounded-lg bg-brand-bg dark:bg-strokedark/60 text-brand-navy dark:text-white hover:bg-brand-blue-tint hover:text-brand-vib transition-colors font-mono text-[11px] border border-brand-line/60 dark:border-strokedark"
        >
          &quot;amazon&quot;
        </button>
        <button
          type="button"
          onClick={() => handleChipClick('electricity bills')}
          className="px-2.5 py-0.5 rounded-lg bg-brand-bg dark:bg-strokedark/60 text-brand-navy dark:text-white hover:bg-brand-blue-tint hover:text-brand-vib transition-colors font-mono text-[11px] border border-brand-line/60 dark:border-strokedark"
        >
          &quot;electricity bills&quot;
        </button>
        <button
          type="button"
          onClick={() => handleChipClick('invoices over €500')}
          className="px-2.5 py-0.5 rounded-lg bg-brand-bg dark:bg-strokedark/60 text-brand-navy dark:text-white hover:bg-brand-blue-tint hover:text-brand-vib transition-colors font-mono text-[11px] border border-brand-line/60 dark:border-strokedark"
        >
          &quot;invoices over €500&quot;
        </button>
      </div>
    </div>
  );
}
